import { connect } from "react-redux";

import {
    addInstance,
    copyInstanceAction,
    LastInstanceBehaviour,
    removeInstance,
} from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { withResolvePaths } from "../../withResolvePaths";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withViewModelSelect } from "../../withViewModelSelect";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";

import { RowMenu } from "./RowMenu";

export interface RowMenuContainerProps {
    bindingPath: AbsoluteModelPath;
    maxOccurs?: EvaluableProp<number>;
    doNotCopyPaths: string[];
    viewModelSelect: ViewModelSelect;
    optional?: boolean;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: RowMenuContainerProps) => {
    if (ownProps.maxOccurs != undefined) {
        const instanceCount = ownProps.viewModelSelect.children(state, ownProps.bindingPath)?.length ?? 0;
        const maxOccurs = ownProps.processEvaluableProp(state, ownProps.maxOccurs);
        return {
            addItemsDisabled: instanceCount >= maxOccurs,
        };
    }
    return {
        addItemsDisabled: false,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: RowMenuContainerProps) => ({
    onRemoveInstance: (bindingPath: AbsoluteResolvedModelPath, index: string) =>
        dispatch(
            removeInstance(
                bindingPath,
                index,
                ownProps.optional ? LastInstanceBehaviour.Remove : LastInstanceBehaviour.Clear
            )
        ),
    onAddInstanceAfter: (bindingPath: AbsoluteResolvedModelPath, index: string) =>
        dispatch(addInstance(bindingPath, undefined, undefined, index)),
    onAddInstanceBefore: (bindingPath: AbsoluteResolvedModelPath, index: string) =>
        dispatch(addInstance(bindingPath, undefined, undefined, undefined, index)),
    onCopyInstance: (bindingPath: AbsoluteResolvedModelPath, sourceInstance: string, insertAfterInstance?: string) =>
        dispatch(copyInstanceAction(bindingPath, sourceInstance, ownProps.doNotCopyPaths, insertAfterInstance)),
});

export const RowMenuContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps, mapDispatchToProps)(RowMenu)))
);
